import { render, staticRenderFns } from "./createTable.vue?vue&type=template&id=979c460a"
import script from "./createTable.vue?vue&type=script&lang=js"
export * from "./createTable.vue?vue&type=script&lang=js"
import style0 from "./createTable.vue?vue&type=style&index=0&id=979c460a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports